import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=fb8c4fac&scoped=true"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"
import style0 from "./Messenger.vue?vue&type=style&index=0&id=fb8c4fac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c4fac",
  null
  
)

export default component.exports